module.exports = __webpack_public_path__ + "static/media/stella_kang.0f2316da.png";